module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 187
// module chunks = 0